
import React, { useState } from "react";
import IndependentResearcherFeed from "./IndependentResearcherFeed";
import IndependentResearcherRealWorldProblems from "./IndependentResearcherRealWorldProblems";
import { IndependentResearherProfile } from "./IndependentResearherProfile"
import IndustryProfiles from "./IndustryProfiles";
import UniversityAnnouncements from "./UniversityAnnouncements";
const IndependentResearcherHome = ({searchTerm,searchParams,setSearchResults}) => {
   const [activeTab,setActiveTab] = useState("feed")
  return (
    <div className="container mx-auto md:px-4 mt-6 mb-4">

      <div className="flex relative">
        <div className="hidden md:block w-1/4 px-2">
          <div className="sticky top-[80px] max-h-[calc(100vh-80px)] overflow-y-auto scrollbar-hidden">
            <IndependentResearherProfile />
          </div>
        </div>
        {/* Center Section */}
        <div className="w-full md:w-2/4 md:px-2">
         <div className="sticky top-[80px] max-h-[calc(100vh-80px)] overflow-y-auto scrollbar-hidden">
          <div className="flex gap-4 w-full pb-4">
  <button onClick={()=>setActiveTab('feed')} className={`w-1/2 py-2 text-center ${activeTab === 'feed' ? 'bg-[#0f6abf] hover:bg-[#0a5ca8]' :'bg-gray-200'} text-white rounded-[10px]`}>
    Feed
  </button>
  <button onClick={()=>setActiveTab('opportunity')} className={`w-1/2 py-2 text-center ${activeTab === 'opportunity' ? 'bg-[#0f6abf] hover:bg-[#0a5ca8]' :'bg-gray-200'} text-white rounded-[10px]`}>
    Opportunity
  </button>
    <button onClick={()=>setActiveTab('announcement')} className={`w-1/2 py-2 text-center ${activeTab === 'announcement' ? 'bg-[#0f6abf] hover:bg-[#0a5ca8]' :'bg-gray-200'} text-white rounded-[10px]`}>
    Annoucements
  </button>
</div>
           {
            activeTab === 'feed' &&  <IndependentResearcherFeed searchTerm={searchTerm} searchParams={searchParams} setSearchResults={setSearchResults}/> 
           }
           {
            activeTab === 'opportunity' && <IndependentResearcherRealWorldProblems/>
           }
           {
            activeTab === 'announcement' && <UniversityAnnouncements/>
           }
          </div>
        </div>
        <div className="hidden md:block w-1/4 px-2">
          <div className="sticky top-[80px]  max-h-[calc(100vh-80px)] overflow-y-auto scrollbar-hidden">
            <IndustryProfiles/>
          </div>
        </div>
      </div>
    </div>
  )
}

export default React.memo(IndependentResearcherHome)